// @flow

import React, { useState, useEffect } from 'react';
import { log } from '../../utils/jsUtils';
import { useSelector } from 'react-redux';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';

import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';

import CreditCardForm from '../SharedComponents/CreditCardForm';
import SPBackend from '../../services/SPBackend';
import StripeElementWrapper from './StripeElementWrapper';
import { useTheme } from '@mui/material/styles';
import { createClasses } from '../../utils/stylesUtils';
import styles from './Styles/ConfirmTopupPurchaseDialog.Style';
import sharedDialogStyles from '../Styles/SharedDialogStyles';
import Typography from '@mui/material/Typography';
import { selectUser } from '../../reduxStore/modules/user/selectors';

import type { Plan } from '../../services/SPBackend';

type Props = {
  setOpen: Function,
  setSelectedPlan: Function,
  isActionLoading: Boolean,
  open: boolean,
  selectedPlan: Plan,
  triggerAction: Function,
  defaultPaymentMethod: Object
};

// eslint-disable-next-line react/no-multi-comp
const ConfirmTopupPurchaseDialog = (props: Props) => {
  const theme = useTheme();
  const classes = createClasses({
    ...styles,
    ...sharedDialogStyles
  }, theme);
  
  const {
    selectedPlan,
    setSelectedPlan,
    setOpen,
    open,
    triggerAction,
    isActionLoading,
    defaultPaymentMethod
  } = props;
  
  const user = useSelector(selectUser);
  

  log('[confirmtopup render] defaultPaymentMethod: ', defaultPaymentMethod);
  const [newDefaultPM, setNewDefaultPM] = useState(null);

  const onPaymentMethodSelected = (pm) => {
    log('[ConfirmTopupPurchaseDialog.onPaymentMethodSelected] pm: ', pm);
    setNewDefaultPM(pm);
  };

  return (<>
    {
      selectedPlan
      ? <Dialog aria-labelledby='form-confirm-topup'
          onClose={() => setOpen(false)}
          open={open}
        >
            <DialogTitle sx={classes.dialogHeader}>{'Checkout'}</DialogTitle>
            <DialogContent sx={{ ...classes.grow, ...classes.flexContainer }}>
              <Box sx={classes.itemHeader}>Item</Box>
              <Box sx={classes.itemList}>
                <Box sx={classes.itemRow}>
                  <Box sx={classes.itemDesc}>
                    {`${Number(selectedPlan.UsageLimit).toLocaleString()} Credits Recharge`}
                  </Box>
                  <Box sx={classes.itemPrice}>
                    ${selectedPlan.Price}
                  </Box>
                </Box>
              </Box>
              <br />
              {
                defaultPaymentMethod
                ? <Typography
                    sx={classes.captionText}
                    variant='body1'
                  >Your credit card ending in {defaultPaymentMethod.card.last4} will be charged.</Typography>
                : !newDefaultPM
                  ? [
                    <Typography 
                      sx={classes.captionText}
                      variant='body1'
                    ><b>No payment method on file yet. Enter your card details:</b></Typography>,
                    <CreditCardForm 
                      onPaymentMethodSelected={onPaymentMethodSelected}
                    />
                  ]
                  : <Typography
                      sx={classes.captionText}
                      variant='body1'
                    >Your credit card ending in {newDefaultPM.card.last4} will be charged.</Typography>
              }
              
              <br />
            </DialogContent>
            <DialogActions>
              <Button
                color='primary'
                onClick={(event) => {
                  event.preventDefault();
                  setSelectedPlan(null);
                  setOpen(false);
                }}
                type='button'
              >
                {'Cancel'}
              </Button>
              
              <Button
                color='primary'
                disabled={isActionLoading || (
                  !defaultPaymentMethod && !newDefaultPM
                )}
                onClick={triggerAction}
                type='submit'
                variant='contained'
              >
                {`Pay $${selectedPlan.Price}`}
              </Button>
            </DialogActions>
        </Dialog>
      : null
    }
    </>
  );
};

export default ConfirmTopupPurchaseDialog;
